import AdaptiveStore from "ember-simple-auth/session-stores/adaptive";

export default class SessionStore extends AdaptiveStore {}
